import { registerSW } from 'virtual:pwa-register';
import { initPwaInstall } from './services/pwaInstallService';

export * from './services/pwaInstallService';

/**
 * Initialise l'enregistrement du Service Worker PWA
 * et active la mise à jour automatique sans rechargement bloquant.
 */
export function initPWA() {
  // Initialise la capture du prompt d'installation native Chrome
  initPwaInstall();

  // 1. Gestionnaire d'erreur de préchargement de chunk Vite (quand une nouvelle version est déployée)
  window.addEventListener('vite:preloadError', (event) => {
    console.warn('[Zeyilo PWA] Nouveau déploiement détecté (chunk obsolète), rechargement en cours...');
    // Évite la boucle infinie si le réseau est coupé
    const lastReload = sessionStorage.getItem('last_preload_reload');
    const now = Date.now();
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem('last_preload_reload', String(now));
      window.location.reload();
    }
  });

  // 2. Enregistrement du Service Worker
  if ('serviceWorker' in navigator) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });

    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        console.log('[Zeyilo PWA] Nouvelle version prête, mise à jour active...');
        updateSW(true);
      },
      onOfflineReady() {
        console.log('[Zeyilo PWA] Application disponible hors-ligne');
      },
      onRegisteredSW(swUrl, registration) {
        console.log('[Zeyilo PWA] Service Worker actif:', swUrl);
        if (registration) {
          // Vérification immédiate et périodique des mises à jour toutes les 15 minutes
          registration.update().catch(() => {});
          setInterval(() => {
            registration.update().catch(() => {});
          }, 15 * 60 * 1000);
        }
      },
      onRegisterError(error) {
        console.warn('[Zeyilo PWA] Échec de l\'enregistrement SW:', error);
      },
    });
  }
}
